/** Same standalone entry decision for bootstrap, routing and document links. */
export function isRuntimeIdentityRoute(pathname) {
    if (typeof pathname !== 'string') return false;
    try { return decodeURIComponent(pathname).toLowerCase().replace(/\/+$/, '') === '/admin/runtime-identity'; }
    catch (_) { return false; }
}
